module.exports = __webpack_public_path__ + "static/img/companybanner.285cc3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/companybanner.png
// module id = 2/O9
// module chunks = 1